import isUrl from 'validator/lib/isURL'

const safeIsUrl = (str) => {
    return str && typeof str === 'string' && isUrl(str);
}

export { safeIsUrl };